// extracted by mini-css-extract-plugin
export var header = "_vq-1";
export var maskBottom = "_vq-6";
export var maskMiddle = "_vq-7";
export var maskTop = "_vq-5";
export var root = "_vq-0";
export var scrollDownButton = "_vq-3";
export var scrollDownButtonHidden = "_vq-4";
export var viewport = "_vq-2";